import servise from '@/router/axios'

export const getCpsApp = (params) => {
  return servise({
    url: '/webCpsApp/list',
    method: 'get',
    params
  })
}
